/**
 * Combined Listing Sibling-Fetch Swap
 *
 * Handles clicks on [data-sibling-url] pills in the combined-listing-picker
 * snippet. Instead of full page reload, fetches the sibling product's section
 * HTML and swaps it in place, then re-inits dependent JS modules and updates
 * the browser URL via history.pushState.
 *
 * Triggers custom event 'combined-listing:swapped' on window
 * so dependent code (find-my-pot, add-to-cart) can re-init.
 */
(function () {
  'use strict';

  const SECTION_SELECTOR = '#combined-listing-section';
  const PICKER_SELECTOR = '[data-sibling-url]';

  let isFetching = false;

  function findSection() {
    return document.querySelector(SECTION_SELECTOR);
  }

  async function swapToSibling(url) {
    if (isFetching) return;
    const sectionId = findSection()?.dataset.sectionId;
    if (!sectionId) {
      console.warn('[combined-listing-swap] no section id, falling back to full reload');
      window.location.href = url;
      return;
    }
    const fetchUrl = `${url}?section_id=${sectionId}`;
    isFetching = true;
    try {
      const res = await fetch(fetchUrl, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error(`fetch failed: ${res.status}`);
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newSection = tmp.querySelector(SECTION_SELECTOR);
      if (!newSection) throw new Error('new section not found in response');

      findSection().replaceWith(newSection);
      window.history.pushState({}, '', url);
      window.dispatchEvent(new CustomEvent('combined-listing:swapped', { detail: { url } }));
    } catch (err) {
      console.error('[combined-listing-swap] fallback to reload:', err);
      window.location.href = url;
    } finally {
      isFetching = false;
    }
  }

  function onClick(e) {
    const pill = e.target.closest(PICKER_SELECTOR);
    if (!pill) return;
    const url = pill.dataset.siblingUrl;
    if (!url) return;
    const targetPath = new URL(url, window.location.origin).pathname;
    if (targetPath === window.location.pathname) return;
    e.preventDefault();
    swapToSibling(targetPath);
  }

  document.addEventListener('click', onClick);
})();
